import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import { Stack } from "@mui/material";
import Papa from 'papaparse';
import Card from '@mui/material/Card';
import { DateInput } from "semantic-ui-calendar-react";
import UploadIcon from '@mui/icons-material/Upload';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function UploadSelectionList() {

    // Variable Declarations
    const [campaign_id, setCampaignId] = useState("");
    const [campus_id, setCampusId] = useState("");
    const [department_id, setDepartmentId] = useState("");
    const [degree_id, setDegreeId] = useState("");
    const [voucher_due_date, setVoucherDueDate] = useState("");
    const [preffered_class_timing, setPrefferedClassTiming] = useState("");
    const [admission_category, setAdmissionCategory] = useState("");
    const [admission_sub_category, setAdmissionSubCategory] = useState("");
    const [selection_remarks, setSelectionRemarks] = useState("");
    const [additional_remarks, setAdditionalRemarks] = useState("");
    const [all_campaigns, setAllCampaigns] = useState([]);
    const [all_campuses, setAllCampuses] = useState([]);
    const [all_departments, setAllDepartments] = useState([]);
    const [all_degrees, setAllDegrees] = useState([]);
    const [csvData, setCsvData] = useState([]);

    const [formErrors, setFormErrors] = useState({
        campaign_id,
        campus_id,
        department_id,
        degree_id,
        voucher_due_date,
        preffered_class_timing,
        admission_category,
        selection_remarks,
    });

    const callErrors = (CAMPAIGNID, CAMPUSID, DEPARTMENTID, DEGREEID, VOUCHERDUEDATE, PREFFEREDCLASSTIMING, ADMISSIONCATEGORY, SELECTIONREMARKS) => {
        const errors = {};
        if (CAMPAIGNID === "") {
            errors.campaign_id = " * Select a Campaign";
        }
        if (CAMPUSID === "") {
            errors.campus_id = " * Select a Campus";
        }
        if (DEPARTMENTID === "") {
            errors.department_id = " * Select a Department";
        }
        if (DEGREEID === "") {
            errors.degree_id = " * Select a Degree";
        }
        if (VOUCHERDUEDATE === "") {
            errors.voucher_due_date = " * Please Enter a Voucher Due Date";
        }
        if (PREFFEREDCLASSTIMING === "") {
            errors.preffered_class_timing = " * Select a Preffered Class Timing";
        }
        if (ADMISSIONCATEGORY === "") {
            errors.admission_category = " * Select a Admission Category";
        }
        if (SELECTIONREMARKS === "") {
            errors.selection_remarks = " * Please Enter Selection Remarks";
        }

        setFormErrors(errors);
    };

    const handleFocus = (e) => {
        const { name } = e.target;

        setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            [name]: "",
        }));
    };

    const handleCampaign = (value) => {
        setCampaignId(value);
    };

    const handleCampus = (value) => {
        setCampusId(value);
        getAllDepartments(value);
    };

    const handleDepartment = (value) => {
        setDepartmentId(value);
        getAllDegrees(value);
    }

    const handleDegree = (value) => {
        setDegreeId(value);
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        Papa.parse(file, {
            complete: (result) => {
                setCsvData(result.data);
            },
            header: true,
        });
    };

    const handlePostRequest = () => {
        if (
            campaign_id &&
            campus_id &&
            department_id &&
            degree_id &&
            voucher_due_date &&
            preffered_class_timing &&
            admission_category &&
            selection_remarks
        ) {
            postSelectionList();
        } else {
            callErrors(
                campaign_id,
                campus_id,
                department_id,
                degree_id,
                voucher_due_date,
                preffered_class_timing,
                admission_category,
                selection_remarks,
            );
        }
    };

    // GET Api calls
    const getAllCampaigns = async () => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        };
        await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setAllCampaigns(data.campaigns);
            })
            .catch((error) => console.log(error));
    };

    const getAllCampuses = async () => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        };
        await fetch(BASE_URL + `/campus/get_campuses`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setAllCampuses(data.campuses);
            })
            .catch((error) => console.log(error));
    };

    const getAllDepartments = async (value) => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        };
        await fetch(BASE_URL + `/department/get_departments_by_campus/${value}`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setAllDepartments(data.departments);
            })
            .catch((error) => console.log(error));
    };

    const getAllDegrees = async (value) => {
        console.log('vale: ', value);
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        };
        await fetch(BASE_URL + `/degree/get_degrees_by_department/${value}`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setAllDegrees(data.degrees);
            })
            .catch((error) => console.log(error));
    };

    // POST API Call
    const postSelectionList = async () => {
        let data = { campaign_id, campus_id, department_id, degree_id, voucher_due_date, preffered_class_timing, admission_category, admission_sub_category, selection_remarks, additional_remarks, selection_list: csvData }
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${token}`
            },
            body: JSON.stringify(data),
        };
        await fetch(`${BASE_URL}/application/upload_selected_applications`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                toast.success("Selection List Uploaded");
                setCampaignId("");
                setCampusId("");
                setDepartmentId("");
                setDegreeId("");
                setVoucherDueDate("");
                setSelectionRemarks("");
                setPrefferedClassTiming("");
                setAdmissionCategory("");
                setAdmissionSubCategory("");
                setAdditionalRemarks("");
                setCsvData("");
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        getAllCampaigns();
        getAllCampuses();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <ToastContainer />
            <MDBox pl={2} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <div className="mt-3">
                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={10}>
                                <Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={1}>
                                    <h3 style={{ color: "red" }}>Please follow instructions below to ensure proper Selection List Upload:</h3>
                                    <h6 style={{ marginLeft: "10px" }}>1. Make sure to review your Selection List data carefully before upload.</h6>
                                    <h6 style={{ marginLeft: "10px" }}>2. Separate Entry needs to be uploaded for each Selection List, any list containing mixed Applications IDs will not be processed.</h6>
                                    <h6 style={{ marginLeft: "10px" }}>3. Test Results file should only contain 2 columms with data for &quot;merit_no&quot; and &quot;applicant_id&quot;. See the sample file: <a href='selection_list_template.csv' download>Selection List Template</a></h6>
                                </Stack>
                                <input type="file" className="form-control" onChange={handleFileChange} />
                            </Stack>
                        </div>

                        <Card className="mt-3" style={{ padding: "30px" }}>
                            <h3>Degree Program Selection</h3>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} padding={2}>
                                <div className="col-md-3">
                                    <label>Campaign</label>
                                    <Dropdown
                                        id="campaign_id"
                                        name="campaign_id"
                                        placeholder="Select Campaign Type"
                                        fluid
                                        selection
                                        value={campaign_id}
                                        onFocus={handleFocus}
                                        onChange={(e, { value }) => handleCampaign(value)}
                                        options={all_campaigns.map((camp) => ({
                                            key: camp.id,
                                            text: camp.name,
                                            value: camp.id,
                                        }))}
                                    />
                                    <div style={{ color: "red" }}>{formErrors.campaign_id}</div>
                                </div>

                                <div className="col-md-3">
                                    <label>Campus</label>
                                    <Dropdown
                                        id="filter_campus_id"
                                        name="filter_campus_id"
                                        placeholder="Select Campus"
                                        fluid
                                        selection
                                        search
                                        value={campus_id}
                                        onFocus={handleFocus}
                                        onChange={(e, { value }) => handleCampus(value)}
                                        options={all_campuses.map((camp) => ({
                                            key: camp.id,
                                            text: camp.name,
                                            value: camp.id,
                                        }))}
                                    />
                                    <div style={{ color: "red" }}>{formErrors.campus_id}</div>
                                </div>

                                <div className="col-md-3">
                                    <label>Department</label>
                                    <Dropdown
                                        id="filter_department_id"
                                        name="filter_department_id"
                                        placeholder="Select Departments"
                                        fluid
                                        search
                                        selection
                                        value={department_id}
                                        onFocus={handleFocus}
                                        onChange={(e, { value }) => handleDepartment(value)}
                                        options={all_departments.map((dept) => ({
                                            key: dept.id,
                                            text: dept.department_name,
                                            value: dept.department_id,
                                        }))}
                                    />
                                    <div style={{ color: "red" }}>{formErrors.department_id}</div>
                                </div>

                                <div className="col-md-3">
                                    <label>Degree</label>
                                    <Dropdown
                                        id="degree_id"
                                        name="degree_id"
                                        placeholder="Select Degree"
                                        fluid
                                        selection
                                        value={degree_id}
                                        onFocus={handleFocus}
                                        onChange={(e, { value }) => handleDegree(value)}
                                        options={all_degrees.map((deg) => ({
                                            key: deg.id,
                                            text: deg.program_name,
                                            value: deg.id,
                                        }))}
                                    />
                                    <div style={{ color: "red" }}>{formErrors.degree_id}</div>
                                </div>
                            </Stack>
                        </Card>

                        <Card className="mt-3" style={{ padding: "30px" }}>
                            <h3>Selection Details</h3>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} padding={2}>

                                <div className="col-md-3">
                                    <label>Voucher Due Date</label>
                                    <DateInput
                                        name="voucher_due_date"
                                        placeholder="Voucher Due Date"
                                        value={voucher_due_date}
                                        iconPosition="left"
                                        onChange={(e, { name, value }) => setVoucherDueDate(value)}
                                    />
                                    <div style={{ color: "red" }}>{formErrors.voucher_due_date}</div>
                                </div>

                                <div className="col-md-9">
                                    <label>Selection Remarks Name</label>
                                    <input
                                        name="selection_remarks"
                                        type="text"
                                        value={selection_remarks}
                                        onFocus={handleFocus}
                                        onChange={(e) => setSelectionRemarks(e.target.value)}
                                        className="form-control form-control-lg"
                                    />
                                    <div style={{ color: "red" }}>{formErrors.selection_remarks}</div>
                                </div>
                            </Stack>

                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} padding={2}>
                                <div className="col-md-4">
                                    <label>Preffered Class Timing</label>
                                    <Dropdown
                                        id="preffered_class_timing"
                                        name="preffered_class_timing"
                                        placeholder="Select Preffered Class Timing "
                                        fluid
                                        selection
                                        onFocus={handleFocus}
                                        value={preffered_class_timing}
                                        onChange={(e, { value }) => setPrefferedClassTiming(value)}
                                        options={[
                                            {
                                                key: "",
                                                text: "",
                                                value: "",
                                            },
                                            {
                                                key: "1",
                                                text: "Morning",
                                                value: "Morning",
                                            },
                                            {
                                                key: "2",
                                                text: "Afternoon",
                                                value: "Afternoon",
                                            },
                                            {
                                                key: "3",
                                                text: "Evening",
                                                value: "Evening",
                                            },
                                            {
                                                key: "3",
                                                text: "Weekend",
                                                value: "Weekend",
                                            },
                                        ]}
                                    />
                                    <div style={{ color: "red" }}>{formErrors.preffered_class_timing}</div>
                                </div>

                                <div className="col-md-4">
                                    <label>Admission Category</label>
                                    <Dropdown
                                        id="admission_category"
                                        name="admission_category"
                                        placeholder="Select Admission Category "
                                        fluid
                                        selection
                                        value={admission_category}
                                        onFocus={handleFocus}
                                        onChange={(e, { value }) => setAdmissionCategory(value)}
                                        options={[
                                            {
                                                key: "",
                                                text: "",
                                                value: "",
                                            },
                                            {
                                                key: "1",
                                                text: "Regular",
                                                value: "Regular",
                                            },
                                            {
                                                key: "2",
                                                text: "International",
                                                value: "International",
                                            },
                                            {
                                                key: "3",
                                                text: "Quota",
                                                value: "Quota",
                                            },
                                        ]}
                                    />
                                    <div style={{ color: "red" }}>{formErrors.admission_category}</div>
                                </div>

                                <div className="col-md-4">
                                    <label>Admission Sub-Category</label>
                                    <Dropdown
                                        id="admission_sub_category"
                                        name="admission_sub_category"
                                        placeholder="Select Admission Sub-Category "
                                        fluid
                                        selection
                                        value={admission_sub_category}
                                        onChange={(e, { value }) => setAdmissionSubCategory(value)}
                                        options={[
                                            {
                                                key: "",
                                                text: "",
                                                value: "",
                                            },
                                            {
                                                key: "1",
                                                text: "Medical Graduate",
                                                value: "Medical Graduate",
                                            },
                                            {
                                                key: "2",
                                                text: "PMDC",
                                                value: "PMDC",
                                            },
                                            {
                                                key: "3",
                                                text: "HEC-Afghan",
                                                value: "HEC-Afghan",
                                            },
                                            {
                                                key: "4",
                                                text: "NSCE",
                                                value: "NSCE",
                                            },
                                            {
                                                key: "5",
                                                text: "SBSC",
                                                value: "SBSC",
                                            },
                                            {
                                                key: "6",
                                                text: "Sports",
                                                value: "Sports",
                                            },
                                        ]}
                                    />
                                </div>
                            </Stack>

                            <Stack direction="row" justifyContent="center" alignItems="center" padding={2}>
                                <div className="col-md-12">
                                    <label>Additional Remarks/Note on Admission Letter</label>
                                    <textarea
                                        name="additional_remarks"
                                        type="text"
                                        value={additional_remarks}
                                        onChange={(e) => setAdditionalRemarks(e.target.value)}
                                        className="form-control form-control-lg"
                                    />
                                </div>
                            </Stack>

                            <Stack direction="row" justifyContent="flex-end" alignItems="center" padding={2}>
                                <Button
                                    variant="contained"
                                    startIcon={<UploadIcon />}
                                    onClick={handlePostRequest}
                                    style={{
                                        borderColor: "white",
                                        fontWeight: "bold",
                                        color: "white",
                                    }}
                                >
                                    Upload Selection List
                                </Button>
                            </Stack>

                        </Card>
                    </Grid>
                </Grid>
            </MDBox>

        </DashboardLayout >
    );
}

export default UploadSelectionList;
